import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import ru from './locales/ru/translation.json'
import uk from './locales/uk/translation.json'

export const resources = {
  ru: {
    translation: ru,
  },
  uk: {
    translation: uk,
  },
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'ru',
    fallbackLng: ['ru', 'uk'],
    defaultNS: 'translation',
    debug: false,
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
